import React, { useEffect, createContext, useState } from "react";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Home from "./pages/Home";
import $axios from "./services/axios";
import { Modal } from "antd";

const ReachableContext = createContext(null);
const config = {
  title: "Token không hợp lệ!",
  maskClosable: false,
  footer: null,
  content: (
    <>
      <ReachableContext.Consumer>
        {(name) => `Có lỗi xảy ra vui lòng trở về trang chủ`}
      </ReachableContext.Consumer>
    </>
  ),
};

const App = () => {
  const location = useLocation();
  const [modal, contextHolder] = Modal.useModal();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyToken =
    queryParams.get("loginToken") ||
    queryParams.get("verifyToken") ||
    queryParams.get("VerifyToken");
  let signature = queryParams.get("signature");
  if (signature) {
    signature = signature.replace(/ /g, "+");
  }
  const [token, setToken] = useState(
    verifyToken ? null : localStorage.getItem("planeToken"),
  );
  const history = useHistory();
  const decodeToken = async () => {
    // Lấy token từ URL
    try {
      if (verifyToken) {
        localStorage.removeItem("planeToken");
        // http://localhost:3000/vemaybay?id_request=3e721dfb0001bc11000601958ea05d00&cif_pk=b1c43db50001bc11000201819907a80b&device_id=FBEE5A462E423686881CB35E1864122F&request_date=1741854629256&signature=H3gSW9W03XaQWTx0O7TB2LgfM7qTr4eOboGN4NEhnqPFXTprdK/zLXj8J0ItbzjzVuWiXdZ2vDpY7/+LDTu5rTV3n+H939kmKyslGUAOKx0q99F83SuYrV12wBF9D3oo+nWL5X1IHi6BztxNGwqd/YtJfjzasrzH5mkWrybNvTtDzdATCVCqQJNKNdaDMF8K/impSudi4DdxyxfQQ9Q6bYHhkVEyur3xgcnDS/KXA5BF6zIyil+ppMmxiJuyKkgp36BTTa+DKMwAYx0ulp7oe1EbktKVj9j0h2YQuabpgVLKEcg0mfgthEuFZbJv97JJ5BmbPH4PPifV0V9aEc6sPw==
        if (verifyToken) {
          const res = await $axios.$post(
            `${process.env.REACT_APP_BASE_URL}/v1/auth/login-hlbank`,
            {
              VerifyToken: verifyToken,
              TypeService: "flight",
            },
          );
          const userInfo = res?.data?.data?.userinfo;
          if (userInfo) {
            userInfo.phone = userInfo?.phone?.replace(/^84/, "0");
            sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          }
          localStorage.setItem("planeToken", res.data.data.accesstoken);
          setToken(res.data.data.accesstoken);
          // history.replace({
          //   pathname: location.pathname,
          // });
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/vemaybay"} />
        <Route
          exact
          path={"/vemaybay"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Route
          exact
          path={"/history"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Redirect to={"/vemaybay"} />
      </Switch>
      {contextHolder}
    </>
  );
};

export default App;
